import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enCommon from "./locales/en/common.json";
import enAuth from "./locales/en/auth.json";
import enApp from "./locales/en/app.json";
import enPages from "./locales/en/pages.json";
import urCommon from "./locales/ur/common.json";
import urAuth from "./locales/ur/auth.json";
import urApp from "./locales/ur/app.json";
import urPages from "./locales/ur/pages.json";

const resources = {
  en: { common: enCommon, auth: enAuth, app: enApp, pages: enPages },
  ur: { common: urCommon, auth: urAuth, app: urApp, pages: urPages },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: ["en", "ur"],
    fallbackLng: "en",
    defaultNS: "common",
    ns: ["common", "auth", "app", "pages"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
  });

export default i18n;
